













































































































import { Component, Vue, Watch } from "vue-property-decorator";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import GenericAdd from "@/core/Generics/GenericAdd";
import Area from "@/models/coding/areaModel";
@Component
export default class AreaAdd extends GenericAdd<Area> {
  constructor() {
    super();
    this.controller = "Areas";
    this.model = new Area();
  }
    saveAll(){
      this.model.areaId = this.$route.params.areaId as any;
      return this.validate();
  }
}
